import { render, staticRenderFns } from "./ASteps.vue?vue&type=template&id=32c31c89"
import script from "./ASteps.vue?vue&type=script&lang=js"
export * from "./ASteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports